import {
  InGameCurrency,
  ManagerProgressionTaskState,
} from '@sorare/core/src/__generated__/globalTypes';
import { useConfigContext } from '@sorare/core/src/contexts/config';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';

export const useWheelTickets = () => {
  const { currentUser } = useCurrentUserContext();
  const {
    wheel: { tasks, nextFreeTicketIn },
  } = useConfigContext();
  const task = tasks[0];
  const ticketCount =
    currentUser?.wheelTickets?.find(
      x => x.currency === InGameCurrency.WHEEL_TICKET
    )?.amount ?? 0;
  const ticketAvailable =
    task?.aasmState === ManagerProgressionTaskState.COMPLETED;
  const canBeDisplayed = nextFreeTicketIn && task?.id;
  const canClaimTicket = canBeDisplayed && ticketAvailable;

  return {
    ticketAvailable,
    canBeDisplayed,
    canClaimTicket,
    ticketCount,
  };
};
